module.exports = __webpack_public_path__ + "img/case-content-bg-sm.aa611ae6.webp";